import { render, staticRenderFns } from "./cardVersionHistory.vue?vue&type=template&id=6a5511c5&scoped=true&"
import script from "./cardVersionHistory.vue?vue&type=script&lang=js&"
export * from "./cardVersionHistory.vue?vue&type=script&lang=js&"
import style0 from "./cardVersionHistory.vue?vue&type=style&index=0&id=6a5511c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5511c5",
  null
  
)

component.options.__file = "cardVersionHistory.vue"
export default component.exports